export default __webpack_public_path__ + "static/media/chevron.201db5e2.svg";